import en from './messages/en.js';
const cache = new Map();
const LAZY_LOADERS = {
    ru: () => import('./messages/ru.js'),
    lv: () => import('./messages/lv.js'),
    de: () => import('./messages/de.js'),
    fr: () => import('./messages/fr.js'),
    es: () => import('./messages/es.js'),
    it: () => import('./messages/it.js'),
    pt: () => import('./messages/pt.js'),
    pl: () => import('./messages/pl.js'),
    uk: () => import('./messages/uk.js'),
    ro: () => import('./messages/ro.js'),
    nl: () => import('./messages/nl.js'),
    cs: () => import('./messages/cs.js'),
    sk: () => import('./messages/sk.js'),
    hu: () => import('./messages/hu.js'),
    bg: () => import('./messages/bg.js'),
    el: () => import('./messages/el.js'),
    sv: () => import('./messages/sv.js'),
    nb: () => import('./messages/nb.js'),
    da: () => import('./messages/da.js'),
    fi: () => import('./messages/fi.js'),
    lt: () => import('./messages/lt.js'),
    et: () => import('./messages/et.js'),
    hr: () => import('./messages/hr.js'),
    sr: () => import('./messages/sr.js'),
    sl: () => import('./messages/sl.js'),
    tr: () => import('./messages/tr.js'),
    'zh-CN': () => import('./messages/zh-CN.js'),
    'zh-TW': () => import('./messages/zh-TW.js'),
    ja: () => import('./messages/ja.js'),
    ko: () => import('./messages/ko.js'),
    hi: () => import('./messages/hi.js'),
    id: () => import('./messages/id.js'),
    vi: () => import('./messages/vi.js'),
    th: () => import('./messages/th.js'),
    ms: () => import('./messages/ms.js'),
    fil: () => import('./messages/fil.js'),
    ar: () => import('./messages/ar.js'),
    he: () => import('./messages/he.js'),
    fa: () => import('./messages/fa.js'),
    'pt-BR': () => import('./messages/pt-BR.js'),
    'es-419': () => import('./messages/es-419.js'),
};
/** English catalog bundled synchronously as the canonical fallback. */
export function getEnglishCatalog() {
    return en;
}
/** Loads a locale catalog, using an in-memory cache after the first load. */
export async function loadLocaleCatalog(locale) {
    if (locale === 'en')
        return en;
    const cached = cache.get(locale);
    if (cached)
        return cached;
    const importer = LAZY_LOADERS[locale];
    const mod = await importer();
    cache.set(locale, mod.default);
    return mod.default;
}
//# sourceMappingURL=loaders.js.map